define('controllers/myservices/game/game-detail.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('GameDetailCtrl', ['$scope', '$q', '$filter', '$stateParams', '$state', '$timeout',
        'OpenApp','OpenGW','auiDialog','getServiceList', 'Higame',
        function ($scope, $q, $filter, $stateParams, $state, $timeout,
                  OpenApp, OpenGW,auiDialog,getServiceList, Higame) {

            var prodID = $stateParams.prodID;
            var openStateFilter = mainCons.appConstant.openStateFilter;
            var prodType = null;//产品类型
            var attrs = {};
            $scope.backToList = backToList;
            $scope.delete = deleteSer;
            var Model = $scope.Model = {
                serviceStatus: '未开通',//服务状态
                buoyPubKey: '',//游戏公钥
                buoyPriKey: '',//游戏私钥
                oauthCertFingerprint: '',//指纹认证
                oauthCertFingerprint1: '',//指纹认证
                oauthCertFingerprint2: '',//指纹认证
                oauthCertFingerprint3: '',//指纹认证
                oauthCertFingerprint4: ''//指纹认证
            };
            init();

            function init() {
                getServiceStatus();
                getAppDetail();
                getGameBuoyKey();
            }

            //得到服务状态和prodType
            function getServiceStatus(){
                OpenApp.getProductByID({request: {prodID: [prodID]}}).then(function (data) {

                    if (data.productList[0]) {
                        $scope.product = data.productList[0];
                        data.productList[0].serviceList.forEach(function (v) {
                            if (v.serviceItem == 52) {
                                $scope.product.serviceSingle = v;
                            }
                        });

                        prodType = data.productList[0].prodType;
                        for (var j = 0; j < data.productList[0].serviceList.length; j++) {
                            if (data.productList[0].serviceList[j].serviceItem == 52) {
                                Model.serviceStatus = $filter('auiMapWithDefault')(data.productList[0].serviceList[j].openState, openStateFilter, 0);
                            }
                        }
                    }
                });
            }

            //得到游戏秘钥
            function getGameBuoyKey(){
                Higame.getGameBuoyKey({}).then(function (data) {
                    var resKey = angular.fromJson(data);
                    if (resKey.privateKey) {
                        Model.buoyPriKey = resKey.privateKey;
                    }
                    if (resKey.publicKey) {
                        Model.buoyPubKey = resKey.publicKey;
                    }
                }).catch(function (data) {
                    auiDialog.failSystemError($filter('auiErrorCode')(data.NSP_STATUS));
                })
            }

            //得到应用详情，如果有SHA256指纹认证，显示SHA256指纹认证
            function getAppDetail(){

                var gwParams = {
                    appId: prodID,
                    attrs: ["secret"]
                };
                //获取appsecret
                OpenGW.getAppInfo(gwParams).then(function (data) {
                    Model.appsecret = data.secret;
                });

                // 获取服务提交时间
                getServiceList.getWorkOrdersCreateTime(52,prodID,$scope.productList).then(function (res) {
                    Model.createTime = res;
                });

                OpenApp.getAppDetail({request: {appID: prodID}}).then(function (appInfoData) {
                    if (appInfoData && appInfoData.appInfo) {
                        Model.currAppDetail = appInfoData.appInfo;
                        attrs = appInfoData.appInfo.appAttrs? appInfoData.appInfo.appAttrs:{};
                        $scope.appInfo = appInfoData.appInfo;
                        $scope.prodType = appInfoData.appInfo.prodType;
                        if (AUI.BaseJSUtil.existy(attrs.oauthCertFingerprint)) {
                            //免安装应用-rpk sha256指纹比较特别
                            Model.oauthCertFingerprint = ($scope.prodType == 19 && $scope.appInfo.freeInstallType == 1) ? attrs.oauthCertFingerprint : AUI.BaseJSUtil.sha2show(attrs.oauthCertFingerprint);
                        }
                        if(AUI.BaseJSUtil.existy(attrs.certFingerprintExtra)){
                            if(typeof attrs.certFingerprintExtra =='string'){
                                var certFingerprintExtraTempDel = attrs.certFingerprintExtra.split(';');
                                if(certFingerprintExtraTempDel.length>0){
                                    for(var h=0;h<certFingerprintExtraTempDel.length;h++ ){
                                        Model['oauthCertFingerprint'+(h+1)] = AUI.BaseJSUtil.sha2show(certFingerprintExtraTempDel[h]);
                                    }
                                }
                            }
                        }
                    }
                });
            }

            //删除
            function deleteSer(prod) {
                getServiceList.deleteAll(prod).then(function (res) {
                    if (res && res.resultCode == 0) {
                        auiDialog.successAndMark('删除成功', function () {
                            backToList();
                        },{isOnShelf:'4'});
                    }
                });
            }

            function backToList() {
                $scope.queryList();
                $state.go('myServiceList',{serviceItem:'52'});
            }

        }]);
});
